import Axios from '../axios'
import { TFunction } from 'i18next'
import { IDepositData } from '../../interfaces/i-api-creaditCard'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'
import appConfig from '../../../app.config'

async function getDepositDataService(userRef: string, t: TFunction) {
	const response = await Axios.get<IDepositData>(
		`${appConfig.customerDataBaseUrl}/api/deposit/agreement?customerId=${userRef}`,
		await getHeadersWithJwtToken(),
	)
		.then((result) => {
			return result.data as IDepositData
		})
		.catch((err) => {
			logError(err)
			if (err.response?.status === 404) {
				throw new Error(t('NoAccounts'))
			} else {
				throw err
			}
		})
	return response as IDepositData
}

export default getDepositDataService
